import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { defaultLanguage } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import ExportButton from "./ExportButton";
import { connect } from "react-redux";
import { checkCartValidity } from "../../redux/cart/action";

const ExportWrapper = ({ checkCartValidity }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggle = () => {
    const isValid = checkCartValidity();

    if (isValid) {
      setModalOpen((prev) => !prev);
    }
  };
  return (
    <>
      <style type="text/css">
        {`
            .btn-export {
                background-color: #0d6efd;
                color: white;
            }
        `}
      </style>
      <Button className="buttonActionCart" color="export" onClick={toggle}>
        <span>
          <i className="fas fa-file-export">
            <span>{language[defaultLanguage].esporta}</span>
          </i>
        </span>
      </Button>
      <Modal centered isOpen={modalOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {language[defaultLanguage].esporta}
        </ModalHeader>
        <ModalBody className="d-flex justify-content-around">
          <ExportButton setModalOpen={setModalOpen} type="pdf" />
          <ExportButton setModalOpen={setModalOpen} type="csv" />
        </ModalBody>
        {/* <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter> */}
      </Modal>
    </>
  );
};

export default connect(null, { checkCartValidity })(ExportWrapper);
